import React, { useContext, useEffect, useState } from 'react';
import { SidebarContext } from '../../context/sidebar';
import { useNavigate } from 'react-router-dom';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { FaPlug, FaTag, FaTachometerAlt, FaShoppingCart, FaDollarSign, FaFile, FaUserTag,FaShareAlt,FaShoppingBag,FaBullhorn    } from 'react-icons/fa';
import styled from 'styled-components';
import companyIcon from '../../images/png/backgroundCompanyIcon2.png'
import cartTiny from '../../images/svg/cat-tiny.svg'
import { FilterSallesContext } from '../../context/filterSalles';

const CardImage = styled.div`
    display: flex;
    margin-top: 1rem;
    justify-content: center;
    margin-bottom: 1rem;

    img {
        width: 132px;
        height: 132px;
        object-fit: contain;
    }

    @media screen and (max-width:720px){
       
        img{
            width: 90px;
            height: 90px;
        }
    }

`;

const IconWrapper = styled.div`
    font-size: 17px; /* Tamanho do ícone */
    margin-bottom: 9px; /* Espaçamento entre os ícones */
`;

const ExitWrapper = styled.div`
    position: absolute;
    bottom: 0;
`;

const ButtonSidebar = styled.button`
    width: 100%;
    border: none;
    margin: 0.5rem auto;
    background-color: white;

    @media screen and (max-width:720px){
        display: none;
        
    }

`;

const NewBadge = styled.span`
    font-family: "Poppins";
    font-weight: 400;
    background-color: #0cbb34;
    color: white;
    font-size: 10px;
    font-weight: bold;
    padding: 2px 5px;
    border-radius: 5px;
    margin-left: 8px;
`;


const SidebarEl = () => {
    const {setOption} = useContext(FilterSallesContext)
    const { sidebarState, handleSidebar } = useContext(SidebarContext)
    const [pathName, setPathName] = useState();
    const [collapsed, setCollapsed] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    
    const navigate = useNavigate();

    const getPathName = () => {
        setPathName(window.location.pathname);
    };
    const handleResize = () => {
        if (window.innerWidth <= 828) {
            setIsMobile(true); // Detecta se é mobile
            setCollapsed(true); // Colapsa o menu automaticamente
        } else {
            setIsMobile(false);
            setCollapsed(false); // Expande o menu em telas grandes
        }
    };
    const handleExit = () => {
        localStorage.clear()
        window.location.href = "/"
    }

    useEffect(() => {
        getPathName();
        handleResize(); // Verifica o tamanho da tela ao montar o componente

        window.addEventListener('resize', handleResize); // Atualiza o estado ao redimensionar

        return () => {
            window.removeEventListener('resize', handleResize); // Limpa o listener quando o componente for desmontado
        };
    }, []);

    return (
        <Sidebar
            collapsed={sidebarState}
            className="sidebar_el"
            style={{
                zIndex: 9999999,
                display: isMobile ? "none" : "block",
                position: isMobile ? "absolute" : "fixed",
                left: isMobile ? (sidebarState ? '-300px' : '0px') : '0px', // Lógica do menu
                transition: 'all 0.3s ease', // Transição suave para o movimento do menu
                height: isMobile ? '100vh' : '100vh',
                width: isMobile ? '40%' : '120px', // Menor largura em mobile
                background: 'white',
                borderRight: '1px solid #d7d7d7',
                borderTopRightRadius: '17px',
                borderBottomRightRadius: '17px',
                
            }}
        >
            <CardImage>
                {sidebarState

                    ?
                    <img src={companyIcon} style={{ width: "50px", height: "50px" }} />
                    :
                    <img src={companyIcon} />
                }
            </CardImage>
            <Menu>
                <IconWrapper>
                    <MenuItem onClick={() => navigate('/dashboard/')} icon={<FaTachometerAlt fontSize={'20px'} />}>
                        Dashboard
                    </MenuItem>
                </IconWrapper>

                <IconWrapper>
                    <SubMenu label="Produtos" icon={<FaTag fontSize={'17px'} />}>
                        <MenuItem onClick={() => navigate('/dashboard/products')}>Meus Produtos</MenuItem>
                        <MenuItem onClick={() => navigate('/dashboard/categorys')}>Minhas Categorias</MenuItem>
                        <MenuItem onClick={() => navigate('/dashboard/sub/categorys')}>Minhas Sub Categorias</MenuItem>
                    </SubMenu>
                </IconWrapper>

                {/* <IconWrapper>
                    <SubMenu label="Integrações" icon={<FaPlug fontSize={'17px'} />}>
                        <MenuItem onClick={() => navigate('/dashboard/mercadolivre')}>Mercado Livre</MenuItem>

                    </SubMenu>
                </IconWrapper> */}

                
                <IconWrapper>
                    <SubMenu label={<>Vendas <NewBadge>Novo</NewBadge></>} icon={<FaShoppingBag fontSize={'17px'} />}>
                        <MenuItem onClick={() => {setOption(1);navigate('/dashboard/sales/order')}}>Pedidos de Vendas</MenuItem>
                    </SubMenu>
                </IconWrapper>


                <IconWrapper>
                    <SubMenu label="Clientes" icon={<FaUserTag fontSize={'19px'} />}>
                        <MenuItem onClick={() => navigate('/dashboard/clients')}>Meus Clientes</MenuItem>

                    </SubMenu>
                </IconWrapper>

                
                <IconWrapper>
                    <SubMenu  label={<>Social <NewBadge>Novo</NewBadge></>} icon={<FaShareAlt fontSize={'19px'} />}>
                        <MenuItem onClick={() => navigate('/dashboard/social/facebook')}>Post Facebook</MenuItem>
                        <MenuItem onClick={() => navigate('/dashboard/social/instagram')}>Post Instragram</MenuItem>
                        <MenuItem onClick={() => navigate('/dashboard/social/google')}>Google Merchant Center</MenuItem>

                    </SubMenu>
                </IconWrapper>

                <IconWrapper>
                    <SubMenu  label={"Marketing"} icon={<FaBullhorn fontSize={'19px'} />}>
                        <MenuItem onClick={() => navigate('/dashboard/marketing/banners')}>Post Banner</MenuItem>
                    </SubMenu>
                </IconWrapper>

                <IconWrapper>
                    <SubMenu
                        label={
                            <>
                                Páginas 
                            </>
                        }
                        icon={<FaFile fontSize={'17px'} />}
                    >
                        <MenuItem onClick={() => navigate('/dashboard/pages')}>Minhas Páginas</MenuItem>
                        <MenuItem onClick={() => navigate('/dashboard/button')}>Meus Botões</MenuItem>
                    </SubMenu>
                </IconWrapper>


                <IconWrapper>
                    <SubMenu label="Carrinhos" icon={<FaShoppingCart fontSize={'18px'} />}>
                        <MenuItem onClick={() => navigate('/dashboard/cart/loss')}>Carrinhos Perdidos</MenuItem>
                    </SubMenu>
                </IconWrapper>

                <IconWrapper>
                    <SubMenu label="Financeiro" icon={<FaDollarSign fontSize={'17px'} />}>
                        <MenuItem onClick={() => navigate("/dashboard/financial")}>Minhas Vendas</MenuItem>
                    </SubMenu>
                </IconWrapper>
{/* 
                <ExitWrapper onClick={() => handleExit()}>
                    <MenuItem icon={<FaSignOutAlt fontSize={'17px'} />}>Sair</MenuItem>
                </ExitWrapper> */}
            </Menu>
        </Sidebar>
    );
};

export default SidebarEl;